import {
  getDocumentaryAssignments,
  getGetDocumentaryAssignmentsQueryKey
} from 'client/api/backend/documentary-assignments/documentary-assignments';
import { GetDocumentaryAssignmentsParams } from 'client/api/backend/schemas';
import { ErrorType } from 'client/core/network/mutators/apiClient';
import {
  QueryFunction,
  QueryKey,
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult
} from 'react-query';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AsyncReturnType<T extends (...args: any) => Promise<any>> = T extends (
  ...args: any
) => Promise<infer R>
  ? R
  : any;

export const InfiniteAssignmentsSearchPageStart = 0;
export const AssignmentsPageSize = 20;

export const useInfiniteAssignmentsSearch = <
  TData = AsyncReturnType<typeof getDocumentaryAssignments>,
  TError = ErrorType<void>
>(
  params?: GetDocumentaryAssignmentsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      AsyncReturnType<typeof getDocumentaryAssignments>,
      TError,
      TData
    >;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options || {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDocumentaryAssignmentsQueryKey(params);

  const queryFn: QueryFunction<
    AsyncReturnType<typeof getDocumentaryAssignments>
  > = ctx =>
    getDocumentaryAssignments({
      ...params!,
      pageNumber: ctx.pageParam ?? InfiniteAssignmentsSearchPageStart
    });

  const query = useInfiniteQuery<
    AsyncReturnType<typeof getDocumentaryAssignments>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions);

  return {
    queryKey,
    ...query
  };
};
